module.exports = __webpack_public_path__ + "static/media/icon-heartrate.ceb8482c.svg";